import Card from 'src/components/card';
import Label from 'src/components/label';
import Text from 'src/components/text';
import { Document } from 'src/types/document';
import CardRow from 'src/components/cardRow';
import Skeleton from 'src/components/skeleton';

type Props = {
  product?: Document;
};

const ProductBatchCard = ({ product }: Props) => {
  if (!product) {
    return <Skeleton height="270px" />;
  }

  return (
    <Card>
      <div>
        <Label>Batch Number (Certificate UID)</Label>
        <Text>{product.productId}</Text>
      </div>
      <div>
        <Label>Passport ID</Label>
        <Text wordBreak>{product.documentBlockchainAddress}</Text>
      </div>
      <CardRow>
        <div>
          <Label>Assembly number</Label>
          <Text>{product.assemblyNumber}</Text>
        </div>
        <div>
          <Label>Control number</Label>
          <Text>{product.controlNumber}</Text>
        </div>
      </CardRow>
    </Card>
  );
};

export default ProductBatchCard;
